module.exports = __webpack_public_path__ + "img/04.916a3524.png";